import { Link } from "react-router-dom";
import { Users, Clock, HeartHandshake } from "lucide-react";
import Seo from "@/components/Seo";
import CalendlyEmbed from "@/components/CalendlyEmbed";

export default function CoachingEnquiry() {
  return (
    <div>
      <Seo
        title="Small-Group Coaching enquiry — reserve your weekly slot"
        description="Book a free consultation for small-group coaching at Kore Wellbeing. Ten members per coach, fixed weekly times, honest technique work and coached progression from day one."
        path="/coaching-enquiry"
      />
      <section className="container-kore pt-16 pb-8 max-w-4xl">
        <span className="eyebrow">Small-Group Coaching</span>
        <h1 className="display-1 mt-4 text-kore-forest">Reserve your slot.</h1>
        <p className="mt-6 text-kore-ink/75 text-lg font-light max-w-2xl leading-relaxed">
          Small-Group Coaching runs in fixed weekly slots with a maximum of ten members per coach. Your specific slot is agreed at your consultation — pick a 30-minute chat below and we'll talk through what's right for you.
        </p>
      </section>

      <section className="container-kore pb-24 grid md:grid-cols-12 gap-10 items-start max-w-6xl">
        <div className="md:col-span-4 bg-kore-forest text-kore-warm rounded-3xl p-10 shadow-lift">
          <div className="eyebrow text-kore-light">What to expect</div>
          <ul className="mt-8 space-y-6 text-sm text-kore-warm/85">
            <li className="flex gap-4">
              <Users size={18} className="text-kore-light mt-0.5 shrink-0" />
              <div><strong>Small groups.</strong><br/>Ten members per coach, so you're properly coached — not lost in a crowd.</div>
            </li>
            <li className="flex gap-4">
              <Clock size={18} className="text-kore-light mt-0.5 shrink-0" />
              <div><strong>Fixed weekly slot.</strong><br/>The same time each week keeps the habit sticky. Life happens — we swap when it does.</div>
            </li>
            <li className="flex gap-4">
              <HeartHandshake size={18} className="text-kore-light mt-0.5 shrink-0" />
              <div><strong>Coached from day one.</strong><br/>Technique, progression and honest support. No experience needed.</div>
            </li>
          </ul>
          <div className="mt-10 pt-8 border-t border-kore-light/20 text-xs text-kore-warm/70 leading-relaxed">
            Coaching sits inside the Kore Coaching membership (£149/month). Consultation is free, no pressure and no pitch.
          </div>
          <div className="mt-8">
            <Link to="/memberships/kore-coached" data-testid="coaching-see-membership" className="text-xs uppercase tracking-[0.2em] text-kore-light hover:underline">
              See what's included →
            </Link>
          </div>
        </div>

        <div className="md:col-span-8 bg-white rounded-3xl border border-kore-ink/10 overflow-hidden shadow-soft">
          <CalendlyEmbed
            utm={{ utmSource: "korewellbeing.com", utmMedium: "web", utmCampaign: "coaching-enquiry" }}
            height={760}
            bookingType="coaching_consultation"
          />
        </div>
      </section>
    </div>
  );
}
